import styled from 'styled-components';

import { theme } from '../../styles/theme';

const StyledModal = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  z-index: 100;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
`;

const StyledModalContent = styled.div<{ fullwidth?: boolean }>`
  width: ${(props) => (props.fullwidth ? '95%' : '')};
  min-width: 400px;
  min-height: 200px;
  max-width: 1200px;
  max-height: 90%;

  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  background-color: ${theme.color.white};
  padding: 2rem;
  box-sizing: border-box;
  border-radius: ${theme.radius.md};
`;

const StyledIconContainer = styled.div`
  width: 100%;
  display: flex;
  position: absolute;
  justify-content: flex-end;
  top: 1rem;
`;

const StyledIcon = styled.div`
  cursor: pointer;
  margin-right: 1rem;
  color: ${theme.color.bodyTextColor};
`;

const StyledTitle = styled.h3`
  padding-bottom: 1rem;
`;

const StyledModalChildren = styled.div`
  margin-top: 1.5rem;
  overflow-y: auto;
`;

export { StyledModal, StyledModalContent, StyledIconContainer, StyledIcon, StyledTitle, StyledModalChildren };
